var map = {
	"./icon-ai.svg": 69720,
	"./icon-annotations.svg": 87600,
	"./icon-apps.svg": 81514,
	"./icon-architecture.svg": 93919,
	"./icon-authentication.svg": 37642,
	"./icon-authorize.svg": 13823,
	"./icon-box-brown.svg": 89814,
	"./icon-box-orange.svg": 66616,
	"./icon-cli.svg": 75732,
	"./icon-code-new.svg": 72792,
	"./icon-code.svg": 89253,
	"./icon-create.svg": 48586,
	"./icon-default.svg": 64053,
	"./icon-document-qa.svg": 11316,
	"./icon-document.svg": 87253,
	"./icon-export.svg": 6104,
	"./icon-gemini.svg": 74651,
	"./icon-gpt.svg": 8817,
	"./icon-guide.svg": 11814,
	"./icon-ios.svg": 27249,
	"./icon-java.svg": 85702,
	"./icon-leaflet.svg": 29237,
	"./icon-mcp.svg": 84242,
	"./icon-metadata.svg": 81613,
	"./icon-model.svg": 40069,
	"./icon-net.svg": 4631,
	"./icon-node.svg": 30066,
	"./icon-palm.svg": 82134,
	"./icon-pen.svg": 25623,
	"./icon-postman.svg": 55208,
	"./icon-python.svg": 97436,
	"./icon-speech-bubble.svg": 10423,
	"./icon-summarisation.svg": 82244,
	"./icon-tool.svg": 39124,
	"./icon-tuning.svg": 95413,
	"./icon-ui-metadata.svg": 88346,
	"./icon-upload.svg": 55389,
	"./icon-users.svg": 27718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94030;